import { useState } from "react";
import { Link } from "react-router-dom";
import { Chrome } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { fmtErr } from "../lib/api";

export default function Login() {
  const { login, register } = useAuth();
  const [mode, setMode] = useState("login");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [name, setName] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      if (mode === "login") await login(email, password);
      else await register(email, password, name);
      sessionStorage.setItem("athanor_splash", "video");
      window.location.assign("/");
    } catch (err) {
      setError(fmtErr(err));
    } finally {
      setLoading(false);
    }
  };

  const googleLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#0b0b0c] px-4">
      <div className="athanor-card w-full max-w-md p-8 fade-up">
        <div className="mb-8 flex flex-col items-center">
          <img src="/athanor-logo.png" alt="Athanor Lab" data-testid="login-logo" className="mb-2 h-20 w-auto object-contain" />
        </div>

        <div className="mb-6 flex rounded-md border border-zinc-800 p-1">
          <button data-testid="tab-login" onClick={() => setMode("login")}
            className={`flex-1 rounded-md px-3 py-1.5 text-sm transition-colors ${mode === "login" ? "chip-on" : "text-slate-400"}`}>
            Accedi
          </button>
          <button data-testid="tab-register" onClick={() => setMode("register")}
            className={`flex-1 rounded-md px-3 py-1.5 text-sm transition-colors ${mode === "register" ? "chip-on" : "text-slate-400"}`}>
            Registrati
          </button>
        </div>

        <form onSubmit={submit} className="space-y-4">
          {mode === "register" && (
            <div>
              <label className="mb-1 block text-xs text-slate-400">Nome</label>
              <input data-testid="register-name-input" value={name} onChange={(e) => setName(e.target.value)} required
                className="w-full rounded-md border border-zinc-800 bg-zinc-900/50 px-3 py-2.5 text-sm text-slate-100 outline-none focus:border-[#C5A059]/60" />
            </div>
          )}
          <div>
            <label className="mb-1 block text-xs text-slate-400">Email</label>
            <input data-testid="login-email-input" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required
              className="w-full rounded-md border border-zinc-800 bg-zinc-900/50 px-3 py-2.5 text-sm text-slate-100 outline-none focus:border-[#C5A059]/60" />
          </div>
          <div>
            <label className="mb-1 block text-xs text-slate-400">Password</label>
            <input data-testid="login-password-input" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required minLength={8}
              className="w-full rounded-md border border-zinc-800 bg-zinc-900/50 px-3 py-2.5 text-sm text-slate-100 outline-none focus:border-[#C5A059]/60" />
          </div>
          {error && <div data-testid="auth-error" className="rounded-md border border-red-500/30 bg-red-500/10 px-3 py-2 text-sm text-red-400">{error}</div>}
          <button type="submit" disabled={loading} data-testid="auth-submit-button"
            className="btn-bronze w-full rounded-md py-2.5 text-sm">
            {loading ? "Attendere..." : mode === "login" ? "Accedi" : "Crea account"}
          </button>
        </form>

        <div className="my-5 flex items-center gap-3 text-xs text-zinc-600">
          <div className="h-px flex-1 bg-zinc-800" /> oppure <div className="h-px flex-1 bg-zinc-800" />
        </div>
        <button onClick={googleLogin} data-testid="google-login-button"
          className="flex w-full items-center justify-center gap-2 rounded-md border border-zinc-700 py-2.5 text-sm text-slate-200 transition-colors hover:border-[#C5A059]/50 hover:bg-zinc-900">
          <Chrome className="h-4 w-4" /> Continua con Google
        </button>

        <div className="mt-5 text-center">
          <Link to="/forgot-password" data-testid="forgot-password-link" className="text-xs text-slate-500 hover:text-[#C5A059]">
            Password dimenticata?
          </Link>
        </div>
      </div>
    </div>
  );
}
